export const TEST_ID = 'componentStatusRow';
